import { render, staticRenderFns } from "./EditSeguroiformapagtoPage.vue?vue&type=template&id=794f2b81"
import script from "./EditSeguroiformapagtoPage.vue?vue&type=script&lang=js"
export * from "./EditSeguroiformapagtoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports